import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData } from '@/auth/utils'
import pages from './routes/pages'
import user from './routes/menu/user'
import others from './routes/menu/others'
import order from './routes/menu/order'
import ticket from './routes/menu/ticket'
import banner from './routes/menu/banner'
import notification from './routes/menu/notification'
import dashboard from './routes/menu/dashboard'
import blog from './routes/menu/blog'
import project from './routes/menu/project'
import product from './routes/menu/product'
import checkErrors from './routes/menu/checkErrors'
import slideshow from './routes/menu/slideshow'
import honor from './routes/menu/honor'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: '',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', name: 'home', redirect: { name: 'user' } },
    ...pages,
    ...user,
    ...others,
    ...order,
    ...ticket,
    ...banner,
    ...slideshow,
    ...dashboard,
    ...blog,
    ...product,
    ...project,
    ...notification,
    ...checkErrors,
      ...honor,
    // {
    //   path: '*',
    //   redirect: 'error-404',
    // },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()

  if (!canNavigate(to)) {
    //   // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'login' })
    //
    // If logged in => not authorized
    return next({ name: 'not-authorized' })
  }

  if (!isLoggedIn && to.name !== 'login') return next({ name: 'login' })

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    next('/')
  }
  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
